module.exports = __webpack_public_path__ + "img/无语.b2992c14.png";